/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMcpVaultTestServer } from "../../funcs/llmMcpVaultTestServer.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.TestMcpServerRequest$inboundSchema,
};

export const tool$llmMcpVaultTestServer: ToolDefinition<typeof args> = {
  name: "llm-mcp-vault-test-server",
  description: `Test MCP server

Connects to an MCP server using the authenticated user's stored credential and returns discovered tool names.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMcpVaultTestServer(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
